import speakerChatroomState from "./speakerChatroom/state"
// console.log(speakerChatroomState, "123432324234242")
const interest_setting = {
  gender: {
    indeterminate: false,
    checkAll: false,
    errMessage: false,
    selectItems: [],
    data: [
      {
        key: "MENS",
        checked: false
      },
      {
        key: "WOMENS",
        checked: false
      },
      {
        key: "KIDS",
        checked: false
      },
      {
        key: "JORDAN",
        checked: false
      },
      {
        key: "OTHERS",
        checked: false
      },
    ]
  },
  division: {
    indeterminate: false,
    checkAll: false,
    errMessage: false,
    selectItems: [],
    data: [
      {
        key: "FOOTWEAR",
        checked: false
      },
      {
        key: "APPAREL",
        checked: false
      },
      {
        key: "EQUIPMENT",
        checked: false
      }
    ]
  },
  planning_intended_use: {
    indeterminate: false,
    checkAll: false,
    errMessage: false,
    selectItems: [],
    data: [
      {
        key: "PERFORMANCE",
        checked: false
      },
      {
        key: "LIFESTYLE",
        checked: false
      },

    ]
  }
}
export default {
  lang: "cn",
  cancel:[], //{name, cancel_fn}
  current_event: {},
  user_info: {},
  ping_interval: {},
  ajax_spin_count: 0,
  current_session_id: null,
  current_session_status: false,
  current_role: '',
  current_event_id:'',
  helper_roles:null,
  event:{},
  isRegister: false,
  assistant_temp_session:null,
  unread_notice_list: [],
  channel_list: [],
  finish_training: false,
  video:{
    play_vod_id: null,
  },
  unread:{
    total_count: 0,
    in_station_count: 0,
    active_count: 0,
    session_count: 0,
    sport_count: 0,
    activity_count: 0
  },
  finish_training:false,
  // is_show
  // ...speakerChatroomState,
  data: {
    version:"",
    classNum: "",// 教室号
    userName: '',// 用户名
    userId:null,// userId
    role: null,// 角色
    client: null,// rtc 实例
    isShowSetting: false,// 是否显示配置项
    isPublish:false,
    isPreview:false,
    isPublishScreen:false, //屏幕分享
    isSwitchScreen:false,// 是否切换大小流
    switchUserId:"",
    userList:[],
    supportInfo:{},
    channel_list: []
  },
  channel_list: [],
  //网站基础数据
  config: {

  },
  place_map:{},
  user_identify:{},
  current_identify:'',
  interest_setting
}



// WEBPACK FOOTER //
// ./src/store/state.js